import { render, staticRenderFns } from "./TreeDocuments.vue?vue&type=template&id=6150c946"
import script from "./TreeDocuments.vue?vue&type=script&lang=js"
export * from "./TreeDocuments.vue?vue&type=script&lang=js"
import style0 from "./TreeDocuments.vue?vue&type=style&index=0&id=6150c946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports